export default Object.freeze({
  UNSET: 0,
  AZ: 1,
  GenerateDate: 2,
  ModifiedDate: 3,
  Shared: 4,
  SharedDate: 5,
  Inactive: 6,
});
